import { render, staticRenderFns } from "./TicTacToe1.vue?vue&type=template&id=3076eea4&scoped=true&"
import script from "./TicTacToe1.vue?vue&type=script&lang=js&"
export * from "./TicTacToe1.vue?vue&type=script&lang=js&"
import style0 from "./TicTacToe1.vue?vue&type=style&index=0&id=3076eea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076eea4",
  null
  
)

export default component.exports